import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit, OnDestroy {
  constructor() {}

  @Input() text: string;

  @Input() route: string;

  @Input() Click: () => void;

  @Input() color: ButtonColor;

  @Input() size: ButtonSize = ButtonSize.SMALL;

  @Input() icon: IconProp;

  @Input() disabled: boolean;

  @Input() style: 'outline' | 'filled' | 'dialog-filled' | 'rounded';

  @Input() loaderObservable: Observable<boolean>;

  @Output() clicked: EventEmitter<any> = new EventEmitter<any>();

  showLoadingIcon: boolean;

  private readonly destroy$: Subject<boolean> = new Subject<boolean>();

  onButtonClick(event) {
    if (this.disabled) {
      return;
    }
    if (this.Click) {
      this.Click.call(null, event);
    }

    this.clicked.emit(event);
  }

  ngOnInit() {
    if (this.loaderObservable) {
      this.loaderObservable.pipe(takeUntil(this.destroy$)).subscribe(
        state => (this.showLoadingIcon = state),
        () => (this.showLoadingIcon = false),
        () => (this.showLoadingIcon = false)
      );
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }
}
